import {
  TaskSubgroup,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createTaskSubgroupMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: TaskSubgroup) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[TaskSubgroupHandler] INSERT TaskSubgroup ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskSubgroup,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[TaskSubgroupHandler] MODIFY TaskSubgroup ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskSubgroup,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[TaskSubgroupHandler] REMOVE TaskSubgroup ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskSubgroup,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[TaskSubgroupHandler] Unknown action for TaskSubgroup:',
            action,
          );
      }
    } catch (error) {
      log.error('[TaskSubgroupHandler] Handler failed:', error);
    }
  };
}
